import { cn } from "@/lib/utils";
import type { LegalSection } from "@/content/legal/legal-types";

type LegalSectionBlockProps = {
  section: LegalSection;
  highlighted?: boolean;
};

function LegalSectionBlock({ section, highlighted = false }: LegalSectionBlockProps) {
  return (
    <section
      id={section.id}
      className={cn(
        "scroll-mt-28 rounded-2xl border p-6 sm:p-7",
        highlighted ? "border-primary/40 bg-primary/5" : "border-border bg-card",
      )}
    >
      <h2 className="font-display text-lg font-semibold tracking-tight text-foreground">
        {section.title}
      </h2>

      {section.paragraphs.map((paragraph, index) => (
        <p
          key={`${section.id}-p-${index}`}
          className="mt-3 text-sm leading-7 text-muted-foreground"
        >
          {paragraph}
        </p>
      ))}

      {section.bullets?.length ? (
        <ul className="mt-3 space-y-2">
          {section.bullets.map((bullet, index) => (
            <li
              key={`${section.id}-b-${index}`}
              className="flex gap-2 text-sm leading-7 text-muted-foreground"
            >
              <span className="mt-0.5 text-primary">•</span>
              <span className="flex-1">{bullet}</span>
            </li>
          ))}
        </ul>
      ) : null}

      {section.footerParagraphs?.map((paragraph, index) => (
        <p
          key={`${section.id}-f-${index}`}
          className="mt-3 text-sm leading-7 text-muted-foreground"
        >
          {paragraph}
        </p>
      ))}
    </section>
  );
}

export { LegalSectionBlock };
